import React, {useState} from 'react';
import Button, { BUTTON_TYPE_CLASSES } from '../Button/Button.component';
import { ProcessButtonContainer } from './ProcessButton.styles';


const ProcessButton = (props) => {

    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
        console.log('rendering ProcessButton');
        console.log(props.buttonText)
        }
    const [processButtonResult, setProcessButtonResult] = useState(null);

    const onClickProcessButton = (functionURL, functionFile, envCode) => {
    
        const apicontext = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            //mode: 'no-cors', // no-cors, *cors, same-origin
            //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            //credentials: 'include', // include, *same-origin, omit
            headers: {
              'Accept': '*/*',
              'Accept-Encoding': 'gzip, deflate, br',
              'Content-Type': 'text/plain',
              'Access-Control-Allow-Origin': '*', 
              //'Access-Control-Allow-Credentials': true, 
              'x-functions-key': ''
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: {
                "{fileName": "}"
            }
          };
        switch(envCode.toLowerCase()) {
            case 'dev':
                apicontext.headers['x-functions-key'] = process.env.REACT_APP_XMLTRANSFORMERTOKEN_DEV
                break;
            case 'sit':
                apicontext.headers['x-functions-key'] = process.env.REACT_APP_XMLTRANSFORMERTOKEN_SIT
                break;
            case 'uat':
                apicontext.headers['x-functions-key'] = process.env.REACT_APP_XMLTRANSFORMERTOKEN_UAT
                break;
            case 'trg':
                apicontext.headers['x-functions-key'] = process.env.REACT_APP_XMLTRANSFORMERTOKEN_TRG
                break;
                default:
                apicontext.headers['x-functions-key'] = ''
    
        
        }
        apicontext.body = '{"fileName": "' +  functionFile + '"}';
        if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
            console.log(functionURL);
            console.log(JSON.stringify(apicontext));
        }
    //    fetch(functionURL, JSON.stringify(apicontext))
        fetch(functionURL, apicontext)
        .then((response) => response.json())
        .then(data => {
            setProcessButtonResult(data);
            if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
            console.log(data)}
        });
      
    };
    
    return (
        <ProcessButtonContainer>
            <Button buttonType={BUTTON_TYPE_CLASSES.trigger} onClick={() => onClickProcessButton(props.buttonUrl, props.fileName, props.envCode)}>{props.buttonText}</Button>
            {processButtonResult && <hr />}
            <div>
                {processButtonResult && <p>Success</p>}
                {processButtonResult && JSON.stringify(processButtonResult)}
            </div>
        </ProcessButtonContainer>
    );

}

export default ProcessButton;